module.exports = __webpack_public_path__ + "img/webp.241359af.svg";